import { FormikHelpers } from "formik";
import { useContext } from "react";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";
import { isTypeOfPhoneCenterSearchForm } from "src/components/Common/UI/SydFilter/SydFilterTypeChecker";
import { IPhoneCenterSearchForm } from "./phoneCenter";
import PhoneCenterSearchForm from "./PhoneCenterSearchForm";

const emptyPhoneCenterSearchForm: IPhoneCenterSearchForm = {
  description: ""
}

const SearchPhoneCenters = () => {
  const sydFilterCtx = useContext(SydFilterContext);

  const activeFilters = sydFilterCtx.activeFilters;
  const clearForm = sydFilterCtx.clearAllFilters;
  const saveFilters  = sydFilterCtx.saveFilters;
  const handleClose = sydFilterCtx.toggleFilterVisibility;

  const initialValues = isTypeOfPhoneCenterSearchForm(activeFilters) ? activeFilters as IPhoneCenterSearchForm : emptyPhoneCenterSearchForm;

  const handleSubmit = async (values: IPhoneCenterSearchForm, { setSubmitting }: FormikHelpers<IPhoneCenterSearchForm>): Promise<void> => {
    saveFilters(values);
    setSubmitting(false);
    handleClose();
  }

  return (
    <PhoneCenterSearchForm initialValues={initialValues} onSubmit={handleSubmit} onClearForm={clearForm} />
  )
}

export default SearchPhoneCenters;